import * as React from "react"
import * as ReactDOM from "react-dom"
import Header from "./components/Header5"
import Footer from "./components/Footer2"
import * as _ from 'lodash'
import * as mockxhr from "mockxhr"
import * as qs from "query-string"
import { num2Zh } from './util/index'
import {
    Table,
    Input,
    Tooltip,
    Icon,
    ConfigProvider,
    Empty,
    Cascader,
} from 'antd'
import "./styles/default.less"
import './styles/desktop/WechatRank.less'

const { Column } = Table

interface IProps {

}

interface IState {
    // 搜索关键词
    search: string
    // 学科配置
    subjectOpt: any[]
    // 已选学科
    subjects: string[]
    // 时间配置
    timeOpt: any[]
    // 已选时间
    time: string
    // 公众号类型配置
    wechatTypeOpt: any[]
    // 已选公众号类型
    wechatType: string
    // 截止日期
    endDate: string
    // 样本数量
    dataNum: number
    // 表格数据
    tableData: any[]
    // 列表数据总数
    dataTotal: number
    // 页码
    page: number
    // 排序关键词
    order: string | undefined
    // 正序or倒序
    sort: string | undefined
    // 加载效果显示状态
    showLoading: boolean
    // 当前选中tab
    currentTab: string
    // 页面类型 公众号还是论文
    pageType: string
}

interface ITableData {
    sourcenid: string
    rank: number
    sourcename: string
    all_read: number
    first_read: number
    max_read: number
    avg_read: number
    all_like: number
    sourceurl: string
    list_Pid: number
}

const COLUMN_OPT = [
    { text: '排名', value: 'rank' },
    { text: '公众号', value: 'sourcename' },
    { text: '总阅读数', value: 'all_read' },
    { text: '头条阅读数', value: 'first_read' },
    { text: '单篇最高阅读数', value: 'max_read' },
    { text: '平均阅读数', value: 'avg_read' },
    { text: '总点赞量', value: 'all_like' },
    { text: '原创文章', value: 'original' },
]

const THESES_COLUMN_OPT = [
    { text: '排名', value: 'rank' },
    { text: '公众号', value: 'sourcename' },
    { text: '论文报导总阅读数', value: 'all_read' },
    { text: '论文报导头条阅读数', value: 'first_read' },
    { text: '论文报导最高阅读数', value: 'max_read' },
    { text: '论文报导平均阅读数', value: 'avg_read' },
    { text: '论文报导总点赞量', value: 'all_like' },
    { text: '论文报导原创文章', value: 'original' },
]

const SUBJECT_ORDER_LIST = [
    '综合',
    '生命科学',
    '医学',
    '计算机与信息科学',
    '化学、材料与能源',
    '地球科学',
    '数理天文',
    '工程学',
    '农学',
    '食品科学与工程',
    '其他',
]

// const SCROLL_OFFECT = 80

// 论文榜单需屏蔽的pid列表
const SHIELD_ID_LIST = [1000, 1002, 1009, 1012, 1028, 1017, 1078, 1083, 1130]

class View extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            search: '',
            subjectOpt: [],
            subjects: [],
            timeOpt: [],
            time: '2019',
            wechatTypeOpt: [],
            wechatType: qs.parse(location.search.replace('?', '')).wechatType || '',
            endDate: '2020年2月3日',
            dataNum: NaN,
            tableData: [],
            dataTotal: 0,
            page: 1,
            order: undefined,
            sort: undefined,
            showLoading: false,
            currentTab: '全部',
            pageType: qs.parse(location.search.replace('?', '')).type,
        }
        this.getSubjectData = this.getSubjectData.bind(this)
        this.getWechatTypeData = this.getWechatTypeData.bind(this)
        this.getTableData = this.getTableData.bind(this)
        this.clickSubjectTab = this.clickSubjectTab.bind(this)
        this.childrenInList = this.childrenInList.bind(this)
        this.subjectItemClick = this.subjectItemClick.bind(this)
        this.subjectAllClick = this.subjectAllClick.bind(this)
    }

    componentDidMount() {
        this.getTableData()
        this.getSubjectData()
        
        // let root = document.querySelector('#root')
        // let wrapper = document.querySelector('.wechat-rank-wrapper')
        // let couldScroll = false

        // if (root && wrapper) {
        //     root.addEventListener('scroll', () => {
        //         if (root && wrapper && (root.scrollTop + root.clientHeight > wrapper.clientHeight - SCROLL_OFFECT)) {
        //             if (!couldScroll) {
        //                 couldScroll = true
        //                 this.setState({
        //                     page: this.state.page + 1,
        //                 }, () => {
        //                     this.getTableData(true)
        //                     setTimeout(() => {
        //                         couldScroll = false
        //                     }, 1000)
        //                 })
        //             }
        //         }
        //     })
        // }
    }

    getSubjectData() {
        mockxhr.POST('https://data.linkresearcher.com/theses/subject', {}, res => {
            let foromatData = _.map(res.data, itm => {
                return {
                        title: _.map(itm, (o, index) => index)[0],
                        children: _.map(_.map(itm, o => o)[0], c => {
                            return {title: c}
                        }),
                }
            })
            let subjectOpt: any[] = []

            _.forEach(SUBJECT_ORDER_LIST, i => {
                _.forEach(foromatData, o => {
                    if (o.title === i) subjectOpt.push(o)
                })
            })

            this.setState({
                subjectOpt,
                currentTab: qs.parse(location.search.replace('?', '')).bigSubject || '全部',
            }, () => {
                let search = qs.parse(location.search.replace('?', ''))

                if (!search.subject) {
                    this.clickSubjectTab(this.getWechatTypeData())
                } else {
                    _.forEach(this.state.subjectOpt, i => {
                        _.forEach(i.children, o => {
                            if (o.title === search.subject) {
                                this.setState({
                                    currentTab: i.title,
                                    subjects: [qs.parse(location.search.replace('?', '')).subject]
                                }, () => this.getWechatTypeData())
                            }
                        })
                    })
                }
            })
        })
    }

    getWechatTypeData() {
        mockxhr.GET('https://data.linkresearcher.com/theses/listtype', {}, res => {
            this.setState({
                wechatTypeOpt: [
                    { text: '全部', value: '' },
                    ..._.map(_.filter(res.data2.list_type, i => i), o => {
                        return { text: o, value: o }
                    })
                ]
            })

            let _date = _.map(res.data2.date, i => i.split('-'))
            let _years = _.uniq(_.map(_date, i => i[0]))
            let _timeOpt: any[] = []
            _.forEach(_years, i => {
                let children: any[] = []

                _.forEach(_date, o => {
                    if (o[0] === i && o[1] !== '0') {
                        children.push({
                            value: o[1],
                            label: `${o[1]}月`,
                        })
                    }
                })

                _timeOpt.push({
                    value: i,
                    label: `${i}年`,
                    children,
                })
            })

            this.setState({
                timeOpt: _timeOpt,
                time: _timeOpt[0].children.length > 0 ? `${_timeOpt[0].value}-${_timeOpt[0].children[0].value}` :  _timeOpt[0].value,
            }, () => this.getTableData())
        })
    }
    
    getTableData(more?: boolean) {
        let theses_type = this.state.pageType === 'theses' ? 1 : undefined

        this.setState({ showLoading: true }, () => {
            mockxhr.POST('https://data.linkresearcher.com/theses/rank', {
                page: this.state.page,
                search: this.state.search,
                order: this.state.order,
                subject: this.state.subjects.length > 0 ? this.state.subjects.join(',') : undefined,
                list_type: this.state.wechatType || undefined,
                sort: this.state.sort === 'descend' ? true : this.state.sort === 'ascend' ? false : undefined,
                size: 20,
                theses_type,
                year: this.state.time.split('-')[0],
                month: this.state.time.split('-')[1] || '0',
            }, res => {
                if (more) {
                    this.setState({
                        tableData: this.state.pageType === 'theses' ? _.map(_.filter(_.filter([...this.state.tableData, ...res.data], i => (i.all_read + i.first_read + i.max_read + i.avg_read + i.all_like) !== 0), o => !SHIELD_ID_LIST.includes(o.list_Pid)), (itm, idx) => {
                            return { ...itm, rank: idx + 1}
                        }) : _.map(_.filter([...this.state.tableData, ...res.data], i => (i.all_read + i.first_read + i.max_read + i.avg_read + i.all_like) !== 0), (itm, idx) => {
                            return { ...itm, rank: idx + 1}
                        })
                    })
                } else {
                    this.setState({
                        tableData: this.state.pageType === 'theses' ? _.map(_.filter(_.filter(res.data, i => (i.all_read + i.first_read + i.max_read + i.avg_read + i.all_like) !== 0), o => !SHIELD_ID_LIST.includes(o.list_Pid)), (itm, idx) => {
                            return { ...itm, rank: idx + 1 }
                        }) : _.map(_.filter(res.data, i => (i.all_read + i.first_read + i.max_read + i.avg_read + i.all_like) !== 0), (itm, idx) => {
                            return { ...itm, rank: idx + 1 }
                        })
                    })
                }
                this.setState({ dataNum: res.sample_size, showLoading: false, dataTotal: res.num })
            })
        })
    }

    clickSubjectTab(done?: any) {
        let { currentTab, subjectOpt } = this.state

        this.setState({ subjects: currentTab !== '全部' ? _.map(_.filter(subjectOpt, i => i.title === currentTab)[0].children, o => o.title) : [] }, () => {
            if (done) done()
        })
    }
    
    childrenInList(children) {
        let flag = true

        _.forEach(_.map(children, c => c.title), i => {
            if (!this.state.subjects.includes(i)) {
                flag = false
                return
            }
        })

        return flag
    }

    subjectItemClick(text, children, done?: any) {
        let flag: boolean = false

        _.forEach(this.state.subjects, i => {
            if (!_.map(children, o => o.title).includes(i)) {
                flag = true
            }
        })

        this.setState({
            subjects: (flag && !this.state.subjects.includes(text)) ? [] : this.state.subjects,
        }, () => {
            if (this.state.subjects.includes(text)) {
                this.setState({
                    subjects: [..._.filter(this.state.subjects, i => i !== text)],
                    page: 1,
                }, () => {
                    if (done) done()
                })
            } else {
                this.setState({
                    subjects: [...this.state.subjects, text],
                    page: 1,
                }, () => {
                    if (done) done()
                })
            }
        })
    }
    
    subjectAllClick(children, done?: any) {
        if (this.childrenInList(children)) {
            this.setState({
                subjects: _.filter(this.state.subjects, i => !_.map(children, c => c.title).includes(i)),
                page: 1,
            }, () => {
                if (done) done()
            })
        } else if (!this.childrenInList(children) && this.state.subjects.length !== 0) {
            this.setState({
                subjects: _.map(children, c => c.title),
                page: 1,
            }, () => {
                if (done) done()
            })
        } else if (!this.childrenInList(children)) {
            this.setState({
                subjects: _.uniq([...this.state.subjects, ..._.map(children, c => c.title)]),
                page: 1,
            }, () => {
                if (done) done()
            })
        }
    }

    render(){
        let { 
            search, 
            subjectOpt, 
            subjects, 
            timeOpt, 
            time, 
            wechatTypeOpt, 
            wechatType, 
            endDate, 
            dataNum, 
            tableData, 
            showLoading, 
            dataTotal,
            currentTab,
            pageType,
        } = this.state

        return(
            <div className='wechat-rank-wrapper'>
                <Header style={{ maxWidth: '1200px', minWidth: '1200px' }}>
                    <div className="head-menu">
                        <div className="tab">
                            <span 
                                className={`text ${pageType === 'wechat' && 'active'}`}
                                onClick={() => location.href=`${location.origin}/wechat_rank?type=wechat&wechatType=${wechatType}&bigSubject=${currentTab}`}
                            >
                                学术公众号数据库
                            </span>
                            <span 
                                className={`text ${pageType === 'theses' && 'active'}`}
                                onClick={() => location.href=`${location.origin}/wechat_rank?type=theses&wechatType=${wechatType}&bigSubject=${currentTab}`}
                            >
                                学术公众号论文可见性提升-数据排行
                            </span>
                        </div>
                        <div className="link" onClick={() => window.open('https://jinshuju.net/f/79dlnn')}>向数据库添加公众号</div>
                    </div>
                </Header>
                <div className="content-wrapper">
                    <div className="search-wrapper">
                        <h1>领研网 · 学术公众号数据库</h1>
                        <Input
                            placeholder="查找公众号"
                            allowClear
                            style={{ width: '566px' }}
                            value={ search }
                            suffix={ <img src="/assets/icons/search.svg" onClick={ () => this.setState({ page: 1, subjects: [], currentTab: '全部' }, () => this.getTableData())} /> }
                            onChange={ e => this.setState({ search: e.target.value }) }
                            onPressEnter={ () => this.setState({ page: 1, subjects: [], currentTab: '全部' }, () => this.getTableData())}
                        />
                    </div>
                    <div className="wechat-subjects-wrapper">
                        <div className="wechat-type-wrapper">
                            {_.map(wechatTypeOpt, i => <div 
                                className={`wechat-type-item ${wechatType === i.value && 'wechat-type-item-active'}`} 
                                onClick={() => {
                                    window.history.pushState({}, '', `/wechat_rank?type=${pageType}&wechatType=${i.value}&bigSubject=${currentTab}`)
                                    this.setState({ wechatType: i.value, page: 1 }, () => {
                                        this.getTableData()
                                    })
                                } }
                            >
                                { i.text }
                            </div>)}
                        </div>
                        <div className="subjects-wrapper">
                            <div className="tab-wrapper">
                                {_.map([{ title: '全部' }, ...subjectOpt], i => <span 
                                    className={`big-subject-item ${i.title === currentTab && 'big-subject-item-active'}`}
                                    onClick={() => {
                                        window.history.pushState({}, '', `/wechat_rank?type=${pageType}&wechatType=${wechatType}&bigSubject=${i.title}`)
                                        this.setState({ currentTab: i.title }, () => this.clickSubjectTab(() => {
                                            this.setState({ page: 1 }, () => this.getTableData())
                                        }))
                                    }}
                                >
                                    <span>{ i.title }</span>
                                </span>)}
                            </div>
                            <div className="subjects-content">
                                {currentTab === '全部' ? <p className='all'>请点击上方“学科大类”后，选择具体学科。</p> : 
                                    currentTab === '综合' ? _.map(_.filter(subjectOpt, i => i.title === currentTab)[0].children, o => <span 
                                        className={`subject-item ${subjects.includes(o.title) && 'subject-item-active'}`}
                                        onClick={() => {
                                            window.history.pushState({}, '', `/wechat_rank?type=${pageType}&wechatType=${wechatType}&bigSubject=${currentTab}`)
                                            this.subjectItemClick(o.title, _.filter(subjectOpt, i => i.title === currentTab)[0].children, this.getTableData)
                                        }}
                                    >
                                        { o.title }<span className='subject-item-close'>x</span>
                                    </span>) :
                                    [<span
                                        className={`subject-item ${this.childrenInList(_.filter(subjectOpt, i => i.title === currentTab)[0].children) && 'subject-item-active'}`} 
                                        onClick={() => {
                                            window.history.pushState({}, '', `/wechat_rank?type=${pageType}&wechatType=${wechatType}&bigSubject=${currentTab}`)
                                            this.subjectAllClick(_.filter(subjectOpt, i => i.title === currentTab)[0].children, this.getTableData)
                                        }}
                                    >
                                        全部<span className='subject-item-close'>x</span>
                                    </span>, ..._.map(_.filter(subjectOpt, i => i.title === currentTab)[0].children, o => <span 
                                        className={`subject-item ${subjects.includes(o.title) && 'subject-item-active'}`}
                                        onClick={() => {
                                            window.history.pushState({}, '', `/wechat_rank?type=${pageType}&wechatType=${wechatType}&bigSubject=${currentTab}`)
                                            this.subjectItemClick(o.title, _.filter(subjectOpt, i => i.title === currentTab)[0].children, this.getTableData)
                                        }}
                                    >
                                        { o.title }<span className='subject-item-close'>x</span>
                                    </span>)]
                                }
                            </div>
                        </div>
                    </div>
                    <div className="filter-wrapper">
                        <div className="filter-block time-filter">
                            <span className="filter-title">统计时间</span>
                            <Cascader
                                style={{ 
                                    width: '110px',
                                    height: '30px',
                                }}
                                expandTrigger="hover"
                                allowClear={false}
                                value={time.split('-')}
                                options={timeOpt}
                                onChange={value => this.setState({ time: value.join('-'), page: 1 }, () => {
                                    this.getTableData()
                                })}
                            />
                        </div>
                        <div className="filter-block end-date">
                            <span className="filter-title">统计数据截至：</span>
                            {endDate}
                        </div>
                        <div className="filter-block data-num">
                            <span className="filter-title">样本数量：</span>
                            { dataNum }
                        </div>
                        <div className="filter-block data-source">
                            <span className="filter-title">数据来源：</span>
                            <span onClick={ () => window.open('https://www.newrank.cn/')}>新榜</span>
                        </div>
                        <div className="filter-block question">
                            <span className="filter-title" onClick={ () => window.open('/')}>常见问题<Icon style={{ marginLeft: '5px' }} type="question-circle" /></span>
                        </div>
                    </div>
                    <div className="table-wrapper">
                        <ConfigProvider 
                            renderEmpty={() => <Empty description={''}>
                                <p 
                                    style={{
                                        cursor: 'pointer',
                                        color: '#290382',
                                        textDecoration: 'underline',
                                    }} 
                                    onClick={() => window.open('https://jinshuju.net/f/79dlnn')}
                                >
                                    没有找到你喜欢的公众号？在这里帮它提名
                                </p>
                            </Empty>}>
                            <Table
                                rowKey={ (record: ITableData) => record.sourcenid }
                                dataSource={ tableData } 
                                pagination={ false }
                                loading={ showLoading }
                                rowClassName={ (record, index) => index % 2 === 0 ? 'row-odd' : 'row-even' }
                                onChange={(pagination, filters, sorter, extra) => {
                                    this.setState({
                                        order: sorter.field,
                                        sort: sorter.order,
                                        page: 1,
                                    }, () => this.getTableData()) 
                                }}
                            >
                                {_.map(pageType === 'theses' ? THESES_COLUMN_OPT :COLUMN_OPT, (o: any) => {
                                    return <Column 
                                        title={ o.text } 
                                        dataIndex={ o.value } 
                                        key={ o.value }
                                        align='center'
                                        sorter={ (o.value !== 'rank' && o.value !== 'sourcename') ? () => 0 : false }
                                        sortDirections={['descend', 'ascend']}
                                        render={(text, record: ITableData) => {
                                            return o.value === 'rank' ? 
                                            <div style={{ 
                                                color:  text <= 3 ? '#290382' : '#333',
                                                fontWeight: text <= 3 ? 600 : 500,
                                            }}>{ text }</div>
                                            : o.value === 'sourcename' ?
                                            <div className='sourcename-wrapper' onClick={() => window.open(`${location.origin}/wechat_rank_detail/${record.list_Pid}?from=${this.state.pageType === 'theses' ? 'theses' : 'wechat'}`)}>
                                                <img src={ record.sourceurl } width='44' height='44' style={{ borderRadius: '50%', marginRight: '10px' }} />
                                                <div>
                                                    <Tooltip 
                                                        placement='right'
                                                        title={ 
                                                            <div className='tooltip-content'>
                                                                <div className='img-wrapper'>
                                                                    <img src={`http://open.weixin.qq.com/qr/code?username=${record.sourcenid}`} width='150px' height='150px' />
                                                                </div>
                                                                <div className="text-wrapper">
                                                                    <p className='title'>扫一扫微信关注</p>
                                                                    <p className='name'>{ text }</p>
                                                                    <p className='id'>{ record.sourcenid }</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    ><div className='sourcename'>{ text }</div></Tooltip>
                                                    <div className='sourcenid'>{ record.sourcenid }</div>
                                                </div>
                                            </div>
                                            : o.value === 'avg_read' ?
                                            <div>{ text }</div>
                                            : o.value === 'max_read' ?
                                            <div>{ num2Zh(text, 5) }</div>
                                            : o.value === 'original' ?
                                            <div>{ `${_.round(text * 10000) / 100}%` }</div>
                                            : <div>{ num2Zh(text) }</div>
                                        }} 
                                />
                            })}
                            </Table>
                        </ConfigProvider>
                    </div>
                    <div 
                        className="more"
                        onClick={() => {
                            this.setState({
                                page: this.state.page + 1,
                            }, () => {
                                this.getTableData(true)
                            })
                        }}
                    >
                        {
                            tableData.length === dataTotal ? '已经到底了'
                            : showLoading ? 
                            '正在加载'
                            : '加载更多'
                        }
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

ReactDOM.render(<View />, document.body.firstChild as any)